import { Option } from '../../lib/types/models/options/option'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getProductDateOptions = (id: number): Promise<Option[]> => {
  return restApiClient.url(constructApiUrl(API.products.getProductOptions.url, { id })).get()
}
